import type { AxiosError } from 'axios';
import { isNil } from 'lodash';
import * as documentService from 'services/documentService';
import type { SWRResponse } from 'swr';
import useSWR from 'swr';

type SWRDocumentsData = Awaited<ReturnType<typeof documentService.getDocumentsAsync>>;

const useDocuments = (load = true): SWRResponse<SWRDocumentsData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_DOCUMENTS_ENDPOINT] : null,
    async ([_]) => await documentService.getDocumentsAsync()
  );

export const SWR_DOCUMENTS_ENDPOINT = 'all-documents';
export default useDocuments;
